import { toast, Flip } from 'react-toastify';
import { POPUP_TYPE } from '../constants';
import { reportError } from './errorReporter';
export const popup = (
  type,
  message,
  position = 'top-right',
  style = {},
  icon = true,
  hideProgressBar = false,
  delay = 400,
) => {
  const toast_style = {
    position,
    autoClose: 8000,
    hideProgressBar,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: true,
    progress: undefined,
    theme: 'light',
    pauseOnFocusLoss: false,
    transition: Flip,
    style,
    icon,
    delay,
    className: 'my-toast',
  };

  switch (type) {
    case POPUP_TYPE.SUCCESS:
      return toast.success(message, toast_style);
    case 'info':
      return toast.info(message, toast_style);
    case POPUP_TYPE.ERR:
      reportError(message, { type: 'popup-error' });
      return toast.error(message, toast_style);
    default:
      return toast(message, toast_style);
  }
};
